import { HttpService } from '../../../../common/api/httpService';
import { PaymentsListRequest, PaymentsListResult, OperationType } from '../../../../models/payments';

export class PaymentsApi {
    private static http = HttpService.getInstance();

    static async list(operation: OperationType, req: PaymentsListRequest): Promise<PaymentsListResult> {
        const api = operation === OperationType.Deposit ? 'Payments/deposits' : 'Payments/withdrawals';
        const result = await this.http.adminFetch(api, 'POST', req);
        if (result.result && result.value) return result.value as PaymentsListResult;
        return { total: 0, items: [], page: req.page, count: req.count };
    }
}


